import { useQuery } from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import { apiGetLangList } from "./service";

export const useGetLangList = (options: any) => {
  return useQuery<any>({
    queryKey: [queryKey.LANG_LIST],
    queryFn: () => apiGetLangList({}).then((res: any) => res.data.data),
    ...options,
  });
};
